import { jsx } from "react/jsx-runtime";
import react from "react";
import { Alert } from "../Alert/index.js";
const SnackbarContent_SnackbarContent = /*#__PURE__*/ react.forwardRef(function({ message, severity, action, ...otherProps }, ref) {
    return /*#__PURE__*/ jsx(Alert, {
        ref: ref,
        ...otherProps,
        severity: severity,
        sx: {
            minWidth: 300,
            ["&.MuiAlert-root"]: {
                alignItems: 'center',
                gap: 1
            }
        },
        "aria-describedby": "snackbar-content",
        Action: action,
        children: /*#__PURE__*/ jsx("div", {
            id: "snackbar-content",
            children: message
        })
    });
});
export { SnackbarContent_SnackbarContent as SnackbarContent };

//# sourceMappingURL=SnackbarContent.js.map